import useWebSocket from 'react-use-websocket';
import { isEnumValid } from '@philips-internal/oswald-ui-utils';
import { PreviewActionType } from '../actions/preview-actions.js';
function getServerURL() {
    if (import.meta.env.PROD) {
        return null;
    }
    const port = import.meta.env.OSWALD_PREVIEW_PORT;
    return `ws://localhost:${port}`;
}
/**
 * Custom hook for managing the WebSocket connection for preview related content within Oswald's editor and applications.
 *
 * @param props - Optional configuration for the hook.
 */
function usePreviewWebSocket(props) {
    const url = getServerURL();
    /**
     * Filter function to determine if a WebSocket message should be accepted.
     *
     * @param event - The WebSocket message event.
     */
    const filter = (event) => {
        const data = JSON.parse(event.data);
        return isEnumValid(PreviewActionType, data.type);
    };
    // @ts-ignore: library's package.json is wrongly configured
    const { sendJsonMessage } = useWebSocket(url, {
        ...props,
        filter,
        reconnectAttempts: 0,
        retryOnError: false,
        share: true,
    });
    return {
        sendMessage: sendJsonMessage,
    };
}
export { usePreviewWebSocket, };
//# sourceMappingURL=use-preview-websocket.js.map